<style>
#server{
	/* padding:30px 30px 8px 30px!important; */
	height: calc(100vh - 128px)!important;
}
#server .q-table__middle{
	overflow-y: hidden !important;
	overflow-x: auto !important;
	height:calc(100% - 48px)!important;
	width: 100%;
}
#server .q-table{
	overflow: hidden !important;
	height:100% !important;
	width: 100%;
}
#server tbody{
	display: block;
	max-height: calc(100vh - 300px);
	height:100%;
	width: 100%;
	overflow: auto;
	webkit-overflow-scrolling: touch;
	will-change: scroll-position;
}
#server .q-table thead{
	height: 48px;
	display: block;
}
#server .q-table thead tr{
	width: 100%;
	display: table;
}
#server .q-table tbody tr{
	width: 100%;
	display: table;/*table-row*/
}
#server .q-table th, #server .q-table tbody td{
    font-size: 0.95rem;
}
#server .q-table th, #server .q-table td {
    padding: 7px 8px;
}
#server .q-table td {
	word-wrap: break-word;
    word-break: break-all;
    white-space: normal;
}
#server .q-table__bottom{
	color: #888;
	position: absolute;
	bottom: 0;
	width: 100%;
	padding: 0 15px;
}
#server .q-table__bottom, #server .q-table__bottom .q-if {
    font-size: 0.88rem;
}
</style>
<template>
  <q-page id="server" padding :style="{padding:screenType?'30px 30px 8px 30px!important':'8px'}">
  	<q-card class="fit">
  		<q-card-section style="height: 60px;padding:10px 15px;">
  			<q-btn @click="btnClick(0,-1)" :label="$t('server.dialog[0]')" icon="fas fa-plus" color="positive" class="q-px-sm" dense>
  				<!--<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{}}</q-tooltip>-->
  			</q-btn>
  			<!--<q-btn @click="btnClick(2,-1)" icon="fas fa-trash-alt" :disable="!selected||selected.length==0" color="red" class="q-ml-md" round dense>
  				<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('delete')}}</q-tooltip>
  			</q-btn>-->
			<q-input v-model="keyword" @keyup.enter="getData(1)" :placeholder="$t('key')" maxlength="15" style="width:210px;float:right;" rounded outlined dense >
			  <template v-slot:after>
			    <q-btn @click="getData(1)" icon="fa fa-search" color="white" text-color="primary" round dense />
			  </template>
			</q-input>
  		</q-card-section>
  		<q-separator />
  		<q-card-section class="q-pa-none" style="height:calc(100% - 60px);"><!-- :selected.sync="selected" selection="multiple"-->
  			<q-table class="fit" :data="listData" :columns="columns" :loading="loading" :pagination.sync="page" :rows-per-page-options="[15,20,30]" row-key="id">
  				<tr slot="header" slot-scope="props">
  					<!--<q-th style="width:4.5%;"><q-checkbox v-if="props.multipleSelect" v-model="props.selected" indeterminate-value="some"/></q-th>-->
          			<q-th key="id" :props="props" style="width:7%;min-width: 50px">ID</q-th>
          			<q-th key="name" :props="props" style="width:35%;min-width: 150px">{{$t('server.name')}}</q-th>
          			<q-th key="type" :props="props" style="width:15%;min-width: 150px">{{$t('type')}}</q-th>
          			<q-th key="url" :props="props" style="width:25%;min-width: 150px">{{$t('server.ip')}}</q-th>
          			<!-- <q-th key="keyAddress" :props="props" style="width:30%;">{{$t('server.address')}}</q-th> -->
          			<q-th key="opt" :props="props" style="width:18%;min-width:135px;">{{$t('opt')}}</q-th>
          		</tr>
          		<q-tr slot="body" slot-scope="props" :props="props">
          			<!--<q-td style="width:4.5%;"><q-checkbox v-model="props.selected"/></q-td>-->
          			<!--<q-td key="id" :props="props" style="width:7%;">{{ (props.row.__index+1)+(curPage-1)*page.rowsPerPage }}</q-td>-->
          			<q-td key="id" :props="props" style="width:7%;min-width: 61px">{{ props.row.id }}</q-td>
          			<q-td key="name" :props="props" style="width:35%;min-width: 150px">{{ props.row.name }}</q-td>
          			<q-td key="type" :props="props" style="width:15%;min-width: 150px">{{ props.row.type }}</q-td>
          			<q-td key="url" :props="props" style="width:25%;min-width: 150px">{{ props.row.url }}</q-td>
          			<!-- <q-td key="keyAddress" :props="props" style="width:30%;">{{ props.row.keyAddress }}</q-td> -->
          			<q-td key="opt" :props="props" style="width:18%;min-width:135px;">
          				<q-btn @click="btnClick(3,props.rowIndex)" icon="fas fa-search" color="positive" size="sm" flat round dense>
          					<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('detail')}}</q-tooltip>
          				</q-btn>
          				<q-btn @click="btnClick(1,props.rowIndex)" icon="fas fa-edit" color="amber-7" class="q-ml-sm" size="sm" flat round dense>
          					<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('modify')}}</q-tooltip>
          				</q-btn>
          				<!-- <q-btn @click="btnClick(2,props.row.__index)" icon="fas fa-trash-alt" color="red" class="q-ml-sm" size="sm" flat round dense>
          					<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('delete')}}</q-tooltip>
          				</q-btn> -->
          			</q-td>
          		</q-tr>
          		<div slot="pagination" slot-scope="props" class="row flex-center q-py-sm">
          			<q-btn @click="pageClick(0)" :disable="curPage<=1" icon="fas fa-arrow-left" color="primary" size="sm" round dense/>
          			<div class="q-mx-md" style="font-size: small"> {{ curPage }} / {{ totalPage }} </div>
          			<q-btn @click="pageClick(1)" :disable="nextPage" icon="fas fa-arrow-right" color="primary" size="sm" round dense/>
          		</div>
  			</q-table>
  		</q-card-section>
  	</q-card>

  	<q-dialog v-model="dialogStatus" persistent transition-show="scale" transition-hide="scale">
    	<q-card  :class="[screenType?'q-pa-lg':'q-pa-sm']" :style="{minWidth:screenType?'450px':'85vw',width:screenType?'':'65vw'}">
        <q-card-section><div class="text-h6">{{dTitle[dialogType]}}</div></q-card-section>
        <q-card-section>
          <div class="fit" v-if="dialogType<2"><!-- 'AS', -->
          	<q-select v-if="dialogType===0" ref="type" v-model="form.type" :label="$t('server.type')" :options="['MS','DS']" outlined
  				:rules="[val => !!val || $t('server.input_type'),]" class="q-mt-sm"/>
          	<q-input ref="name" v-model.trim="form.name" :label="$t('server.name')" class="q-mt-sm" maxlength="20" counter :placeholder="$t('server.name')" outlined
          		:rules="[val => !!val || $t('server.input_name'), val => val.length<=28&&val.length>=4 || $t('server.msg_name')]" lazy-rules/>
          	<q-input  ref="url" v-model.trim="form.url" @keyup.native="keyEnter(0,$event)" :label="$t('server.ip')" class="q-my-sm" maxlength="80" counter :placeholder="$t('server.ip')" outlined
          		:rules="[val=>!!val || $t('server.input_ip'), val=>val.length<=80&&val.length>=5 || $t('server.msg_ip')]" lazy-rules/><!-- , val=>vaild(0,val) || $t('server.err_ip') -->
          	<q-input v-if="dialogType===0" ref="key" v-model.trim="form.keyContent" @keyup.native="keyEnter(1,$event)" :label="$t('server.key')" class="q-my-sm" maxlength="3500" counter type="textarea" autogrow :placeholder="$t('server.key')" outlined
          		:rules="[val => !!val || $t('server.input_key'), val => val.length<=3500&&val.length>=4 || $t('server.msg_key')]" lazy-rules/>
          </div>
          <div v-if="dialogType==3" style="line-height:38px;font-size:15px;margin:0 auto;">
          	    <q-field borderless>
          			<template v-slot:prepend><span style="font-size:15px;">{{$t('server.name')}}：</span></template>
          			<template v-slot:control>
          				<div class="self-center full-width no-outline" tabindex="0">{{form.name}}</div>
          			</template>
          		</q-field>
          		<q-field borderless>
          			<template v-slot:prepend><span style="font-size:15px;">{{$t('server.type')}}：</span></template>
          			<template v-slot:control>
          				<div class="self-center full-width no-outline" tabindex="0">{{form.type}}</div>
          			</template>
          		</q-field>
          		<q-field borderless>
          			<template v-slot:prepend><span style="font-size:15px;">{{$t('server.ip')}}：</span></template>
          			<template v-slot:control>
          				<div class="self-center full-width no-outline" tabindex="0">{{form.url}}</div>
          			</template>
          		</q-field>
          		<q-field borderless>
          			<template v-slot:prepend><span style="font-size:15px;">{{$t('server.address')}}：</span></template>
          			<template v-slot:control>
          				<div class="self-center full-width no-outline" tabindex="0" style="word-wrap:break-word;">{{form.keyAddress}}</div>
          			</template>
          		</q-field>
          		<q-field borderless>
          			<template v-slot:prepend><span style="font-size:15px;">{{$t('server.key')}}：</span></template>
          			<template v-slot:control>
          				<div class="self-center full-width no-outline" tabindex="0" style="word-wrap:break-word;">{{form.keyContent}}</div>
          			</template>
          		</q-field>
          		<q-field borderless>
          			<template v-slot:prepend><span style="font-size:15px;">{{$t('createTime')}}：</span></template>
          			<template v-slot:control>
          				<div class="self-center full-width no-outline" tabindex="0">{{form.createTime |parseDateTime}}</div>
          			</template>
          		</q-field>
          		<q-field borderless>
          			<template v-slot:prepend><span style="font-size:15px;">{{$t('updateTime')}}：</span></template>
          			<template v-slot:control>
          				<div class="self-center full-width no-outline" tabindex="0">{{form.updateTime |parseDateTime}}</div>
          			</template>
          		</q-field>
          </div>
        </q-card-section>
        <q-card-actions align="right" class="bg-white text-teal">
        	<q-btn :label="$t('close')" :flat="dialogType!=3" color="primary" class="q-mr-md" v-close-popup/>
        	<q-btn v-if="dialogType!=3" @click="confirm()" :label="$t('ok')" :disable="btnDisable"  icon="fas fa-check" color="primary"/>
        </q-card-actions>
      </q-card>
    </q-dialog>

  </q-page>
</template>
<script>
export default {
  name: 'server',
  data () {
    return {
    	keyword:null,
    	selected:[],
    	total:0,
    	curPage:1,
    	page:{ page:1, rowsPerPage:20 },
    	loading:false,
    	columns: [{ name: 'id', field: 'id', align: 'left', sortable: true},
        { name: 'name', field: 'name', align: 'left', sortable: true },
        { name: 'type', field: 'type', align: 'left', sortable: true },
        { name: 'url', field: 'url', align: 'left', sortable: true },
        { name: 'keyAddress', field: 'keyAddress', align: 'left', sortable: true },
        { name: 'opt', field: 'opt', align: 'left'},
    	],
    	listData:[],
    	dTitle:this.$t('server.dialog'),
    	dialogStatus:false,
    	dialogType:0,
    	content:{ name:null,type:'MS',url:null,keyContent:null, },
    	form:{},
		btnDisable:false,
    }
  },
  props:['lang'],
  filters: {
    	parseDateTime(time){
    		return time?parseDateTime(time):time;
    	}
    },
  watch:{
  	lang(val, oldVal){
    	this.columns = this.columns;
    },
    pageCount(val, oldVal){//选每页数量 size
    	if(val){
    		this.curPage = 1;
    		this.getData(this.curPage);
    	}
    },
  },
  computed: {
	  			screenType() {
      return _isPC(); //this.$q.platform.is.desktop
    },
  	nextPage(){
  		return this.curPage>=Math.ceil(this.total/this.page.rowsPerPage);
  	},
  	totalPage(){
  		return Math.ceil(this.total/this.page.rowsPerPage);
  	},
  	pageCount(){
  		return this.page.rowsPerPage;
  	}
  },
  created(){
  	this.form = JSON.parse(JSON.stringify(this.content));
  	if(localStorage.getItem("AS_token") && localStorage.getItem("AS_token").length>0) {
    	this.getData(1);
  	}else{
  		this.$router.replace('/');//login
  	}
  },
  methods: {
	keyEnter(type,e){ //输入限制
		if(type==0){//域名
			e.target.value = e.target.value.replace(/[^\w\.\:\/]/g, '');
		}else if(type==1){//密钥
			e.target.value = e.target.value.replace(/[^\w\+\/]/g, '');
		}
	},
  	vaild(type,val){ //输入验证
		if(type===0){//域名
			var exp =  /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*(\/\w+)*$/;
			// /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
			return val.match(exp)
		}else if(type===1){//IP
			var exp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
			return val.match(exp)
		}
  	},
  	openDialog(type){
  		this.dialogType = type;
  		this.dialogStatus = true;
  	},
  	getData(index){
    	this.listData = [];
    	this.loading = true;
    	var request = {};
    	//request.ids = [];
		if(this.keyword) request.keyword = this.keyword;
    	request.paging = { index:(index-1)*this.page.rowsPerPage, count:this.page.rowsPerPage, sort:'desc' };
    	this.$ajax(1,'post',true,'/server/list',request).then((res)=>{
    		this.listData = res.data;
    		this.total = res.paging.total;
    		setTimeout(() => { this.loading = false }, 800);
    	}).catch((err)=>{
    		console.log(err)
    		setTimeout(() => { this.loading = false }, 800);
    		this.$emit('islogin',index==1?0:1,err);
    		//if(err.code) this.$notify(2,err.msg,null);
    	})
    },
  	btnClick(type,index){
  		if(type===0){//添加
  			this.form = JSON.parse(JSON.stringify(this.content));
  		}else if(type===1||type==3){//修改/查看
  			this.form = JSON.parse(JSON.stringify(this.listData[index]));
  			this.$ajax(1,'get',true,'/server/'+this.form.id,null).then((res)=>{
				this.form = res.data;
  				if(res.data.keyContent) this.form.keyContent = res.data.keyContent;
  			}).catch((err)=>{ })
  		}else if(type===2){ //删除
  			this.$q.dialog({
    			title: this.$t('msg.prompt'),
    			message: this.$t('server.msg_del') + this.listData[index].name+' ?',
    			persistent: true,
    			cancel: true,
  			}).onOk((result) => {
    			this.$ajax(1,'delete',true,'/server/'+this.listData[index].id,null).then((res)=>{
    				this.getData(this.curPage);
    				this.$notify(1,this.$t('server.ok_del'),null);
    			}).catch((err)=>{
    				console.log(err)
    				this.$emit('islogin',1,err);
    				//if(err.code) this.$notify(2,err.msg,null);
    			})
  			}).onCancel((err) => { })
  		}
  		if(type!=2) setTimeout(()=>{ this.openDialog(type); },500);
  	},
  	confirm(){
  		this.$refs.name.validate();
  		if(this.dialogType===0){//添加
  			this.$refs.type.validate();
  			this.$refs.url.validate();
  			this.$refs.key.validate();
  			if (this.$refs.name.hasError||this.$refs.type.hasError||this.$refs.url.hasError||this.$refs.key.hasError) {
  				this.$notify(2,this.$t('msg.input_err'),null);
  				return
  			}else{
				this.btnDisable = true;
  				var request = {};
  				request.name = this.form.name;
  				request.type = this.form.type;
  				request.url = this.form.url;
  				request.publicKey = this.form.keyContent;
    			this.$ajax(2,'put',true,'/server',request).then((res)=>{
    				this.getData(this.curPage);
    				this.dialogStatus = false;
					this.btnDisable = false;
    				this.$notify(1,this.$t('server.ok_add'),null);
    			}).catch((err)=>{
    				console.log(err)
    				this.$emit('islogin',1,err);
					this.btnDisable = false;
    				//if(err.code) this.$notify(2,err.msg,null);
    			})
  			}
  		}
  		else if(this.dialogType===1){//修改
  			if (this.$refs.name.hasError) {
  				this.$notify(2,this.$t('msg.input_err'),null);
  				return
  			}else{
				this.btnDisable = true;
  				var request = {};
  				request.name = this.form.name;
				request.url = this.form.url;
  				request.keyContent = this.form.keyContent;
    			this.$ajax(1,'post',true,'/server/'+this.form.id,request).then((res)=>{
    				this.getData(this.curPage);
    				this.dialogStatus = false;
					this.btnDisable = false;
    				this.$notify(1,this.$t('server.ok_modify'),null);
    			}).catch((err)=>{
    				console.log(err)
    				this.$emit('islogin',1,err);
					this.btnDisable = false;
    				//if(err.code) this.$notify(2,err.msg,null);
    			})
  			}
  		}
  	},
  	pageClick(type){//点击页数 type:0-,1+
    	this.curPage= type? this.curPage+1:this.curPage-1;
    	if(this.curPage>0&&this.total!==0&&this.listData.length<this.total){
    		this.getData(this.curPage);
    	}
    },
  }
}
</script>
